import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';
import { sleep } from '../../../web3/utils';

const useTotalStakedSpool = () => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error, mutate } = useSWR(interfaceSDK ? 'totalStakedSpool' : null, () =>
        interfaceSDK!.get.getTotalStakedSpool()
    );

    const update = async (previousValue?: string) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            if (currentValue !== previousValue) {
                break;
            }

            retries++;
            await sleep(3000);
        } while (retries < 5);
    };

    return {
        totalStakedSpool: data,
        isLoading: !error && !data,
        error,
        updatTotalStakedSpool: update,
    };
};

export default useTotalStakedSpool;
